import React, { Component } from 'react';

class ContentWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    
    render() {
        let { children } = this.props;
        return (
            <div className="marketkit-toast-content-wrapper">
                { children }
            </div>
        )
    }
}

export default ContentWrapper;